import { ROUTES } from "../../../../module/constants";
import { generalConst } from "../../../../module/globalInterface";

const CREATE_PATH = "create";
const MODIFY_PATH = "edit";

export const BR_MGMT_CONSOLE_ADMIN_URLS: generalConst = {
  BASE_URL: ROUTES.ADMIN_BR_MGMT,
  STEP_TWO: `${ROUTES.ADMIN_BR_MGMT}/stepTwo`,
  MODIFY_STEP_ONE: `${ROUTES.ADMIN_BR_MGMT}/${MODIFY_PATH}/stepOne`,
  MODIFY_STEP_TWO: `${ROUTES.ADMIN_BR_MGMT}/${MODIFY_PATH}/stepTwo`,
  MODIFY_STEP_SUMMARY: `${ROUTES.ADMIN_BR_MGMT}/${MODIFY_PATH}/summary`,
  CREATE_STEP_ONE: `${ROUTES.ADMIN_BR_MGMT}/${CREATE_PATH}/stepOne`,
  CREATE_STEP_TWO: `${ROUTES.ADMIN_BR_MGMT}/${CREATE_PATH}/stepTwo`,
  CREATE_STEP_SUMMARY: `${ROUTES.ADMIN_BR_MGMT}/${CREATE_PATH}/summary`,
};

export const STATE_IDENTIFIER = {
  LOADER_IDENTIFIER: "loader",
  LIST_IDENTIFIER: "list",
  CALL_STATE: "callState",
  SELECTED_OU: "selectedOu",
  SELECTED_BR: "selectedBR",
  SELECTED_BR_ENTITLEMENTS: "selectedBrEntitlements",
  TARGET_BR: "targetBR",
  ADDED_ENT: "addedEntitlements",
  DELETED_ENT: "deletedEntitlements",
  TOTAL_ENT: "totalEntitlements",
  ENTITLEMENTS: "entitlements",
  SOD_CONFLICTS_BR: "sodConflictsBR",
  CHAIN_ENTITLEMENTS: "chainEntitlements",

  STEP_ONE: "stepOne",
  STEP_TWO: "stepTwo",
  STEP_FOUR: "stepFour",
};
